 /*jshint esversion: 6 */

 import Vue from 'vue'
 import Router from 'vue-router'
 import Reader from '@/components/Reader'
 import Home from '@/components/home'
 import HTML00_COVER from '@/components/html/00_cover'
 import HTMLEBB from '@/components/html/ebb'
 import HTMLTLU from '@/components/html/tlu'
 import HTMLMM from '@/components/html/mm'
 import HTMLLOVE_1 from '@/components/html/love_1'
 import HTML02_TITLE from '@/components/html/02_title'
 import HTML04_C1 from '@/components/html/04_c1'
 import HTML04_C1A from '@/components/html/04_c1a'
 import HTMLLOVE_2 from '@/components/html/love_2'
 import HTML08_CR from '@/components/html/08_cr'
 import HTMLAUBA from '@/components/html/auba'
 import HTMLORIMAD from '@/components/html/ORIMad'
import Last from '@/components/last'

Vue.use(Router)

export default new Router({
	routes: [
	{
 			"path" : "/",
 			"name" : "home",
 			"component" : Home
 		},
 		{
 			"path" : "/html/00_cover",
 			"name" : "html/00_cover",
 			"component" : HTML00_COVER
 		},
 		{
 			"path" : "/html/ebb",
 			"name" : "html/ebb",
 			"component" : HTMLEBB
 		},
 		{
 			"path" : "/html/tlu",
 			"name" : "html/tlu",
 			"component" : HTMLTLU
 		},
 		{
 			"path" : "/html/mm",
 			"name" : "html/mm",
 			"component" : HTMLMM
 		},
 		{
 			"path" : "/html/love_1",
 			"name" : "html/love_1",
 			"component" : HTMLLOVE_1
 		},
 		{
 			"path" : "/html/02_title",
 			"name" : "html/02_title",
 			"component" : HTML02_TITLE
 		},
 		{
 			"path" : "/html/04_c1",
 			"name" : "html/04_c1",
 			"component" : HTML04_C1
 		},
		{
 			"path" : "/last",
 			"name" : "last",
 			"component" : Last
 		},
	]
})


// WEBPACK FOOTER //
// ./src/router/index.js